import config from 'config';
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import AffiliateFooter from 'modules/affiliateOffer/components/AffiliateFooter';
import AffiliateHeader from 'modules/affiliateOffer/components/AffiliateHeader';
import Loader, {
  LoaderWrapper,
} from 'modules/corporateOffer/components/Loader';
import BehindTheAdviceSection from 'modules/corporateOffer/components/sections/BehindTheAdviceSection';
import CoachHeroSection from 'modules/corporateOffer/components/sections/CoachHeroSection';
import {
  Eyebrow,
  SectionDivider,
} from 'modules/corporateOffer/components/sections/headings';
import HowItWorksSection from 'modules/corporateOffer/components/sections/HowItWorksSection';
import MembershipSection from 'modules/corporateOffer/components/sections/MembershipSection';
import SixAreasSection from 'modules/corporateOffer/components/sections/SixAreasSection';
import SuccessStoriesSection from 'modules/corporateOffer/components/sections/SuccessStoriesSection';
import Swoosh from 'modules/corporateOffer/components/Swoosh';

import { useGetAffiliateOffer } from '../../modules/affiliateOffer/hooks';

export const Affiliate = () => {
  const heroRef = useRef<HTMLDivElement>(null);

  const { code } = useParams<{ code: string }>();

  const { data: offerData } = useGetAffiliateOffer(code);

  if (!offerData) {
    return (
      <LoaderWrapper>
        <Loader bigCircleSize={85} smallCircleSize={63} />
      </LoaderWrapper>
    );
  }

  return (
    <Container>
      <Swoosh heroRef={heroRef} />
      <AffiliateHeader
        image={offerData.imageUrl}
        title={`${offerData.affiliateName}’s exclusive offer`}
        body={offerData.bodyText}
        onTryForFreeClick={() =>
          window.open(
            `${config.shidoWebsiteVersion}/sign-up?publicCode=${offerData.publicCode}`,
            '_blank'
          )
        }
      />
      <Layer ref={heroRef}>
        <CoachHeroSection videoSrc="/Shido_Explainer_Consumer.mp4" />
      </Layer>
      <Body>
        <BehindTheAdviceSection />
        <SectionDivider />
        <SuccessStoriesSection
          eyebrow={<Eyebrow>Testimonials</Eyebrow>}
          title="Trusted by 1000’s of people like you"
          withFooter={false}
          withSubtitle={false}
        />
        <SectionDivider $marginTop={false} $marginBottom />
        <HowItWorksSection />
        <SectionDivider $marginBottom />
        <SixAreasSection />
        <SectionDivider />
        <MembershipSection />
      </Body>
      <AffiliateFooter />
    </Container>
  );
};

const Container = styled.main`
  width: 100%;
  position: relative;
  overflow: clip;
  background-color: ${({ theme }) => theme.colors.cream};
`;

// Positioned so the sections paint over the fixed swoosh.
const Layer = styled.div`
  position: relative;
`;

const Body = styled(Layer)`
  padding-bottom: 80px;
`;
